import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientGaming } from "@obg/gaming.config";
import { ProductType } from "@obg/ngx.core";
import { ConfigService, fromMinutesToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class GameCollectionConfigService {
	private collectionNames: Record<string, string> = {
		[ProductType.Casino]: this.getCasinoCollectionName(),
		[ProductType.LiveCasino]: this.getLiveCasinoCollectionName(),
		[ProductType.MiniGames]: this.getMiniGamesCollectionName(),
		[ProductType.TableGames]: this.getTableGamesCollectionName(),
		[ProductType.Keno]: this.getKenoCollectionName(),
		[ProductType.VirtualSports]: this.getVirtualSportsCollectionName(),
		[ProductType.Jackpots]: this.getJackpotsCollectionName(),
		[ProductType.Slots]: this.getSlotsCollectionName(),
		[ProductType.SkillGames]: this.getSkillGamesCollectionName(),
	};

	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientGaming>) {}

	getCacheMaxAgeForGetAll(): number {
		return fromMinutesToMilliseconds(
			this.configService.get((x) => x.gaming.gameCollection.cacheMaxAge!.getAll, 30)
		);
	}

	getGameCollectionEndpoint(): string {
		return this.configService.get((x) => x.gaming.gameCollection.endpoints!.gameCollections, "v2/gamecollections");
	}

	getGameCollectionByIdEndpoint(): string {
		return this.configService.get(
			(x) => x.gaming.gameCollection.endpoints!.gameCollectionById,
			"v1/gamecollections/:collectionId"
		);
	}

	getRouteToCollectionMapping(): Record<string, string> {
		return this.configService.get((x) => x.gaming.gameCollection.routeToCollectionMapping, {});
	}

	getCollectionNameByProduct(product: ProductType): string {
		return this.configService.get((x) => x.gamingUi.root.getCollectionNameByProduct, this.collectionNames)[product];
	}

	getCasinoCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.casinoCollectionName, "Casino");
	}

	getMiniGamesCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.miniGamesCollectionName, "MiniGamesLobby");
	}

	getTableGamesCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.tableGamesCollectionName, "TableGamesLobby");
	}

	getKenoCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.kenoCollectionName, "KenoLobby");
	}

	getLiveCasinoCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.liveCasinoCollectionName, "LiveCasino");
	}

	getVirtualSportsCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.virtualSportsCollectionName, "VirtualSports");
	}

	getSlotsCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.slotsCollectionName, "Slots");
	}

	getSkillGamesCollectionName(): string {
		return this.configService.get((x) => x.gamingUi.root.skillGamesCollectionName, "SkillGames");
	}

	// TODO: EPIC: #AG-2082, add vNext config
	getJackpotsCollectionName(): string {
		return "JackpotsLobby";
	}
}
